/**
*
*/
<template>
<!--  <div>-->
<!--    <van-loading size="24px" vertical>加载中...</van-loading>-->
<!--    -->
<!--  </div>-->
  <nav-page-view title="用户登录" :is-loading="isLoading" :is-show-nav-left="false">
    <p class="err-msg" v-if="msg">{{msg}}</p>
    <p class="err-msg" v-if="errorMsg">{{errorMsg}}</p>
    <van-button v-if="showRegisterNow" class="register-now-btn" block type="primary" size="normal" @click="registerNow">马上注册</van-button>
    <template v-if="showFocusQr">
<!--      <div class="qr-code" v-qr="qrUrl"></div>-->
      <p style="width: 100%; text-align: center;">长按下图二维码，进入微信公众号进行关注</p>
      <div style="margin-top: 50px; text-align: center">
        <img src="@/assets/weixinqr.jpg">
      </div>
    </template>
  </nav-page-view>
</template>

<script>
  import user from "@/common/user";
  import commonUtils from "@/common/commonUtils";
  import NavPageView from "@/components/NavPageView";
  // import FooterInfo from "@/components/FooterInfo";
  // import {Dialog} from "vant";

  export default {
    name: "login-index",
    components: {NavPageView},
    data(){
      return {
        isLoading: true,
        qrUrl: 'http://weixin.qq.com/r/oEx1bc3EVZAqrYkO9xmy',
        type: null, // {String} 登录类型： 1 管局端， 2 企业端 ， 3 订餐
        qrLogin: null,
        errorMsg: '',
        msg: '',
        showRegisterNow: false,
        showFocusQr: false
      }
    },
    created() {
      // debugger
      // console.log("login");
      commonUtils.setOpenId(null);
      let params = commonUtils.queryParams();
      if(params.type){
        this.type = params.type;
      }else {
        this.type = 1
      }
      if(params.qrLogin){
        this.qrLogin = params.qrLogin;
      }
      // 如果没设置登录类型，并且存在登录后回跳页，则根据登录后回跳页设置登录类型
      if(!this.type && commonUtils.getBeforeLoginUrl()){
        this.type = user.getLoginType();
        if(this.type){
          params.type = this.type;
        }
      }

      if ((user.isOrderUser() && this.type != user.TypeOrder)
        || (!user.isOrderUser() && this.type === user.TypeOrder)) {
        user.clearUser();
      }
      // debugger;
      if(params.code && params.state || params.openId){
        // 执行获取OpenId 进行登录
        this.$get('/wechat/login', params, null, 1).then(({data})=>{
          commonUtils.showToastSuccess('登录成功');
          setTimeout(()=>{
              this.setLogin(data);
          }, 1000);
        }).catch((err)=>{
          // console.error("login err: ", err)
          user.clearUser();
          if(err.code === 10002){
            if(err.extData && err.extData.subscribe === 0){
              // subscribe 用户是否订阅该公众号标识，值为0时，代表此用户没有关注该公众号，拉取不到其余信息。
              this.errorMsg = '请先关注该微信公众号！';
              this.showFocusQr = true;
              this.isLoading = false;
            }else {
              // 用户不存在，如果登录前的页面是白单页，则跳转登录前的页面，或则跳转到绑定页
              commonUtils.setOpenId(err.data);
              this.goBindOrBeforePage();
            }
          }else if(err.code === 10003){
            // 用户不可用
            this.isLoading = false;
            this.errorMsg = commonUtils.getErrMsg(err);
            if(err.data){
              commonUtils.setOpenId(err.data);
              this.showRegisterNow = true;
            }else {
              commonUtils.clearBeforeLoginUrl();
            }
            // this.$toast.fail(this.errorMsg);
            // Dialog.alert({
            //   message: this.errorMsg,
            // }).then(() => {
            //   // on close
            // });
          }else {
            this.isLoading = false;
            this.errorMsg = "微信授权登录失败！";
            // Dialog.alert({
            //   message: "微信授权登录失败！",
            // }).then(() => {
            //   // on close
            // });
            // this.$toast.fail("微信授权登录失败！")
          }
          // this.$toast.fail("获取OpenID失败")
        });
      }else {
        commonUtils.initWeiXinSdk(this).then(()=>{
          user.checkLogin(this, false, this.type, params).then((userInfo)=>{
            if((this.type === user.TypeAdmin && user.isClientUser()) || (this.type === user.TypeClient && user.isAdminUser())){
              user.doChangeLogin(this.type);
              // user.clearUser();
            } else if (!user.isOrderUser() && this.type === user.TypeOrder){
                user.clearUser();
                commonUtils.showAlert("订餐系统登录异常！" + this.type + " " + user.TypeOrder + " " + user.getToken()).then(()=>{
                    commonUtils.goLoginPage(this.type);
                });
            } else {
              this.goHome();
            }
          }).catch(()=>{
            // 跳转到微信登录
              commonUtils.showAlert("登录超时，请重新登录").then(()=>{
                  commonUtils.goLoginPage(this.type);
              });
            // console.log("goLoginPage ");
          });
        }).catch((errMsg)=>{
         this.errorMsg = errMsg;
         this.showFocusQr = true;
         this.isLoading = false;
        });
      }
    },
    methods: {
      setLogin(respData){
        user.setLoginUser(respData);
        this.goHome();
      },
      goHome(){
        if(this.qrLogin){
          // 扫码登录处理
          this.msg = '扫码登录处理';
          this.doQrLogin();
        }else {
          user.goUserHomePage();
        }
      },
      doQrLogin(){
        this.$post('/wechat/doQrLogin', {uuid: this.qrLogin}, {}, 2).then(()=>{
          this.msg = '扫码登录成功';
        }).catch((err)=>{
          this.msg = '';
          this.errorMsg = commonUtils.getErrMsg(err);
        }).finally(()=>{
          this.isLoading = false;
        });
      },
      goBindOrBeforePage(){
        // 先判断是否在存登录前页面
        let beforeLoginUrl = commonUtils.getBeforeLoginUrl();
        if(!(beforeLoginUrl && commonUtils.isNotAuthPage(beforeLoginUrl) && commonUtils.goBeforeLoginPage())){
          if (this.type === user.TypeOrder){
            commonUtils.goPage('./order.html#/user/register', true);
          }else {
            commonUtils.goPage('./zqtClient.html#/bind/index', true);
          }
        }
      },
      registerNow(){
        this.goBindOrBeforePage();
      },
    }
  }
</script>

<style scoped lang="less">
  .err-msg{
    text-align: center;
    padding-top: 30px;
  }
  .register-now-btn{
    width: auto;
    margin: 50px auto;
  }
</style>